export const semverCompare = (a, b) => {
  if (a == null) return -1;

  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};
